import useElementSize from '@/hooks/useElementSize'
import { PREVIOUS_PATHNAME_KEY } from '@/pages/legacy/consts/consts'
import { AuthUtils } from '@/utils/AuthUtils'
import { LEGACY_PATH } from '@/utils/consts'
import { PATHS } from '@/utils/routes/paths'
import { Utils } from '@/utils/Utils'
import { FC, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useProgressModal } from '@/contexts/ProgressModalContext'
import { showUnallocatedNotice } from '@/pages/outbound/outboundEtc/unallocatedNotice'

interface Message extends MessageEvent {
  data: VisitLogin | ProgressModalMessage | UnallocatedNoticeMessage
}

interface VisitLogin {
  event: 'VISIT_LOGIN_PAGE'
}

interface UnallocatedNoticeMessage {
  event: 'UNALLOCATED_NOTICE'
  total: number
  unallocated: number
}

interface ProgressModalMessage {
  event: 'PROGRESS_MODAL_OPEN' | 'PROGRESS_MODAL_CLOSE'
}

const InlineFramePage: FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { setIsModalOpen } = useProgressModal()

  const [ref, { width, height }] = useElementSize()
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    if (sessionStorage.getItem(PREVIOUS_PATHNAME_KEY) === pathname) {
      setTimeout(() => {
        iframeRef.current?.contentWindow?.location.reload()
      }, 800)
    }

    sessionStorage.setItem(PREVIOUS_PATHNAME_KEY, pathname)
  }, [pathname])

  useEffect(() => {
    const handleMessage = (message: Message) => {
      switch (message.data.event) {
        case 'VISIT_LOGIN_PAGE':
          AuthUtils.logout()
          navigate(PATHS['auth.login'])
          break
        case 'PROGRESS_MODAL_OPEN':
          setIsModalOpen(true)
          break
        case 'PROGRESS_MODAL_CLOSE':
          setIsModalOpen(false)
          break
        case 'UNALLOCATED_NOTICE':
          // iframe 안에서 띄우면 화면 전체가 아니라 iframe 영역 기준으로 뜨므로 1.0 화면이 셸에 맡긴다
          if (message.origin === window.location.origin) {
            showUnallocatedNotice(message.data.total, message.data.unallocated)
          }
          break
        default:
          return null
      }
    }
    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [navigate, setIsModalOpen])

  return (
    <Wrapper>
      <IframeWrap ref={ref}>
        <iframe
          ref={iframeRef}
          title={pathname}
          src={`${window.location.origin}${LEGACY_PATH}${pathname}?layout=iframe`}
          width={`${width}px`}
          height={`${height}px`}
        />
      </IframeWrap>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 0;
  height: calc(100% + 48px);
  margin: -24px;
  overflow: hidden;
`
const IframeWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  iframe {
    border: 0;
  }
`
export default InlineFramePage
